var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10202_83497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61661 3.96154L2.16404 14.5244C1.49994 15.6103 2.28071 16.9923 3.5461 16.9923H16.4512C17.7166 16.9923 18.4974 15.6013 17.8333 14.5244L11.3807 3.96154C10.7435 2.92949 9.24481 2.92949 8.60763 3.96154H8.61661Z",
    fill: "#3284FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6342 12.3997H9.36583L9.125 7.6875H10.875L10.6342 12.3997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6731 13.0391H9.31641V14.3957H10.6731V13.0391Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10202_83497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 15.1577,
    fill: "white",
    transform: "translate(1.25 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIWarning);
export default __webpack_public_path__ + "static/media/i_warning.a67461170092e15b82e6a107f232a9e6.svg";
export { ForwardRef as ReactComponent };